import React from 'react';
import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import { Tween } from 'react-gsap';
import why_us_banner from '../../../assets/media/home-page/why-us-banner.png';




gsap.registerPlugin(ScrollTrigger);

const WhyUs = () => {
    
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

    return (
        <>
            <Tween
                to={{
                    scrollTrigger: {
                        trigger: "#why-us",
                        start: '150px bottom',
                        end: '250px center',
                        scrub: true,
                        // markers: true
                    },
                    css: {
                        background: '#fff'
                    }
                }}
            >
                <section id="why-us">
                    <div className="container">

                        <div className="why-us-banner-img">
                            <div className="why-us-tittle">
                            <Tween
                                to={{
                                    scrollTrigger: {
                                        trigger: ".why-us-banner-img h1",
                                        start: '-200px center',
                                        end: '200px center',
                                        scrub: true
                                    },
                                    css: {
                                        x: 0,
                                        opacity : 1,
                                    }
                                }}
                            >
                                <h1>Why Us</h1>
                            </Tween>
                            </div>

                            <Tween
                                to={{
                                    scrollTrigger: {
                                        trigger: "#why-us",
                                        start: "center bottom",
                                        end : 'bottom center',
                                        scrub: 0.5
                                    },
                                    css: {
                                        y : viewportWidth > 1000 && 100,
                                        opacity: 1,
                                        scale: viewportWidth > 1000 && 1.1
                                    }
                                }}
                            >
                                <img src={why_us_banner} alt="why_us_banner"/>
                            </Tween>
                        </div>

                        <Tween
                            to={{
                                scrollTrigger: {
                                    trigger: "#why-us",
                                    start: "center bottom",
                                    end : 'bottom center',
                                    scrub: 0.5,
                                    // markers: true
                                },
                                css: {
                                    y: viewportWidth > 1000 ? -80 : 0,
                                    x: viewportWidth > 1000 && 50,
                                    background: viewportWidth > 1000 && 'rgba(0, 105, 148, 1)',
                                    opacity : viewportWidth < 1000 && 1
                                }
                            }}
                        >
                            <div className="why-us-summary">
                                <p>
                                    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Consectetur, sint atque nemo fuga adipisci
                                    error quia alias minus natus sunt reprehenderit aliquam quae nostrum nisi quidem officiis placeat
                                    culpa neque! Lorem ipsum, dolor sit amet consectetur adipisicing elit. Consectetur, sint atque nemo fuga adipisci
                                    error quia alias minus natus sunt reprehenderit aliquam quae nostrum nisi quidem officiis placeat
                                    culpa neque! Lorem ipsum, dolor sit amet consectetur adipisicing elit. Consectetur, sint atque nemo fuga adipisci
                                    error quia alias minus natus sunt reprehenderit aliquam quae nostrum nisi quidem officiis placeat
                                    culpa neque!
                                </p>
                            </div>
                        </Tween>
                    </div>

                    <Tween
                        to={{
                            scrollTrigger: {
                                trigger: "#why-us",
                                start: "center bottom",
                                end : 'bottom center',
                                scrub: 0.5,
                                // markers: true
                            },
                            css: {
                                width : '60%'
                            }
                        }}
                    >
                        <div className="why-us-bg-img">
                            <img src={why_us_banner} alt="why_us_banner"/>
                        </div>
                    </Tween>

                </section>
            </Tween>
        </>
    )
}

export default WhyUs